import state from './moduleTenantsState.js'
import mutations from './moduleTenantsMutations.js'
import actions from './moduleTenantsActions.js'
import getters from './moduleTenantsGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}